const defaultState = {
  isAuthenticated: false,
  authenticationFailed: false,
  language: 'en',
  loadingOnLogin: false,
  firstTimeLoading: true,
  passwordExpired: false,
  passwordChangeError: null,
  isChangingPassword: false
}

export default (state = defaultState, { type, data }) => {

  switch (type) {
    case 'SET_LANGUAGE':
      return { ...state, language: data }
    case 'SET_AUTHENTICATED':
      return { ...state, isAuthenticated: data }
    case 'AUTHENTICATION_FAILED':
      return { ...state, authenticationFailed: true }
    case 'LOADING_ON_LOGIN':
      return { ...state, loadingOnLogin: data }
    case 'FIRST_TIME_LOADING':
      return { ...state, firstTimeLoading: data }
    case 'PASSWORD_EXPIRED':
      return { ...state, passwordExpired: data }
    case 'CHANGE_PASSWORD_REQUEST':
      return {
        ...state,
        isChangingPassword: true,
        passwordChangeError: null
      }
    case 'CHANGE_PASSWORD_SUCCESS':
      return {
        ...state,
        isChangingPassword: false,
        passwordExpired: false,
        passwordChangeError: null
      }
    case 'CHANGE_PASSWORD_ERROR':
      return {
        ...state,
        isChangingPassword: false,
        passwordChangeError: data
      }
    case 'PASSWORD_RESET_SUCCESS':
      return {
        ...state,
        passwordExpired: false
      }
    default:
      return state
  }

}
